import { render, staticRenderFns } from "./authenticationCenter.vue?vue&type=template&id=40a9cd16"
import script from "./authenticationCenter.vue?vue&type=script&lang=js"
export * from "./authenticationCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports